import { Box, Typography } from "@mui/material";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { useMaterials } from "hooks/useMaterials";
import { MassOutlierBand } from "src/store/api/generatedApi";
import { useFormatNumber } from "src/utils/formatNumber";

interface MassOutlierBandSummaryProps {
  band: MassOutlierBand | null | undefined;
  mass: string | null | undefined;
}

export const MassOutlierBandSummary = ({
  band,
  mass,
}: MassOutlierBandSummaryProps) => {
  const { t } = useTenantTranslation();
  const formatNumber = useFormatNumber();
  const formatUnits = useUnitsFormatter(false);
  const { materials } = useMaterials();

  if (band == null) {
    return null;
  }

  const massValue = mass == null ? Number.NaN : Number(mass);
  const massLabel = Number.isFinite(massValue)
    ? `${formatNumber(2, true)(massValue)}${formatUnits("mass")}`
    : t("unknown");
  const materialLabel =
    (materials ?? []).find((material) => material.name === band.material)
      ?.labelling_name ?? band.material;

  return (
    <Box>
      <Typography variant="body2">
        {t("massOutlierBandEventMass", { mass: massLabel })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t("massOutlierBandTypical", {
          material: materialLabel,
          low: formatNumber(2, true)(band.low),
          high: `${formatNumber(2, true)(band.high)}${formatUnits("mass")}`,
        })}
      </Typography>
    </Box>
  );
};
